import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import get from "lodash/get";
import ENV from '@/config/environment';
import { getLocalAccessToken, deleteAllCookies, deleteCookie } from '@/helpers/helpers';
import { store } from '@/store/store';

Vue.use(VueAxios, axios);

const getUserByAccessToken = async () => {
  const accessToken = store.getters.accessToken == null ? getLocalAccessToken() : store.getters.accessToken;

  if(!accessToken) {
    deleteCookie('accessToken');
    store.dispatch('updateAccessToken', null);
    store.dispatch('updateUserStatus');
    return undefined;
  }

  try {
    const res = await Vue.axios.get(ENV.apis.getUserByAccessToken, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': typeof accessToken === 'string' ? accessToken : 'none',
      }
    });
    const user = get(res, 'data.user');
    return user ? user : undefined;
  } catch(e) {
    if(e.response.status == 401) {
      deleteCookie('accessToken');
      store.dispatch('updateAccessToken', null);
      store.dispatch('updateUserStatus');
    }
    return undefined;
  }
};

const logout = async () => {
  try {
    store.dispatch('updateUserStatus');
    localStorage.clear();
    localStorage.loggingOut = 'true';
    localStorage.clear();
    const res = await Vue.axios.get(ENV.apis.logout);
    deleteAllCookies();
    return res;
  } catch(error) {
    return undefined;
  }
};

const resetPasswordByEmail = async (email) => {
  const data = {
    'clientId': ENV.clientId,
    'emailAddress': email
  }
  try {
    const res = await Vue.axios.post(ENV.apis.resetPasswordByEmail, data);

    const status = get(res, 'status');
    if(status === 'error') {
      return undefined;
    }
    //track event
    return res;
  } catch(e) {
    return undefined;
  }
};

export {
  getUserByAccessToken,
  resetPasswordByEmail,
  logout
};